<template>
  <div class="header">
    <div class="headerbox">
      <div class="logo">
        <img src="/img/logo.png" alt="" />
      </div>
      <el-menu
        class="list"
        :default-active="activeIndex"
        background-color="transparent"
        text-color="#fff"
        active-text-color="#fff"
        @select="handleSelect"
      >
        <el-menu-item index="/home">
          <span :class="tabsName == '首页' ? 'select' : ''">首页</span>
        </el-menu-item>
        <el-menu-item
          v-for="(item, index) in navList"
          :key="index"
          :class="tabsName == item.title ? 'select' : ''"
          :index="item.title"
        >
          <span>{{ item.title }}</span>
        </el-menu-item>
        <el-menu-item index="/about">
          <span :class="tabsName == '关于我们' ? 'select' : ''">关于我们</span>
        </el-menu-item>
      </el-menu>
      <div class="search">
        <input
          type="text"
          v-model="searchText"
          placeholder="请输入关键字"
          @keyup.enter="searchClick"
        />
        <img src="/img/newPages/sousuo.png" alt="" @click="searchClick" />
        <div class="line"></div>
      </div>
      <div class="xiazai" @click="client()">
        <img src="/img/xiazai.05b01857.png" alt="" />
      </div>
      <div class="touxiang" @click="personal()">
        <img v-if="$store.state.avatar" :src="$store.state.avatar" alt="" />
        <img v-else src="/img/newPages/touxiang.png" alt="" />
      </div>
      <login-toast
        :status="loginStatus"
        :isClose="changeStatus"
        @resign="resignFn"
      />
      <registered-toast
        :state="registeredState"
        :isClose="closeRegisterFn"
        @resign="resignFn"
      />
      <forget-pwd
        :state="fargetState"
        :isClose="forgetFn"
        @resign="resignFn"
      />
      <bridge-iframe :login-data="loginData" />
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'
import { getUser, getToken } from '@/utils/auth'
import LoginToast from '@/components/auth/LoginToast.vue'
import RegisteredToast from '@/components/auth/RegisteredToast.vue'
import ForgetPwd from '@/components/auth/ForgetPwd.vue'
import BridgeIframe from '@/components/auth/BridgeIframe.vue'

export default {
  name: 'MainHeader',
  components: {
    LoginToast,
    RegisteredToast,
    ForgetPwd,
    BridgeIframe
  },
  data() {
    this.$axios({
      url: '/realNet/pageManager/getPageManagers',
      method: 'get',
      headers: { token: '123456789' }
    }).then(res => {
      if (res.data.result && res.data.result.content) {
        let rmhdItem = null
        const currentPath = decodeURI(this.$router.currentRoute.fullPath)
        res.data.result.content.map((item) => {
          if (item.title) {
            switch (item.title) {
              case 'RMHD下载':
                rmhdItem = item
                break
              case '首页':
              case '搜索':
                break
              default:
                this.navPath[item.title] = item.url
                this.navList.push(item)
            }
          }
          if ('/about' == currentPath) {
            this.tabsName = '关于我们'
          }
          if (item.url == currentPath) {
            this.tabsName = item.title
          }
        })
        if (rmhdItem) {
          this.navPath[rmhdItem.title] = rmhdItem.url
          this.navList.push(rmhdItem)
        }
      }
    })
    return {
      activeIndex: '1',
      loginStatus: false,
      registeredState: false,
      fargetState: false,
      clearKey: false,
      navList: [],
      navPath: {},
      loginData: null,
      searchText: '',
      tabsName: '首页'
    }
  },
  watch: {
    clearKey() {
      if (this.clearKey) this.searchText = ''
      this.tabsName = '首页'
    }
  },
  methods: {
    searchClick() {
      EventBus.$emit('searchEvent', this.searchText)
      this.$router.push({ path: '/search', query: { searchText: this.searchText } })
    },
    personal() {
      if (getUser()) {
        this.$router.push('/mine')
      } else {
        this.loginStatus = true
      }
      this.clearKey = true
    },
    client() {
      window.open('https://resstatic.today365.com.cn/index.html')
    },
    handleSelect(key) {
      switch (key) {
        case '/login':
          if (getUser()) {
            this.$router.push('/mine')
          } else {
            this.loginStatus = true
          }
          this.clearKey = true
          break
        case '/':
        case '/home':
          this.$router.push('/')
          if (getUser() != null) {
            const user = JSON.parse(getUser())
            this.$store.state.name = user.name
          }
          this.clearKey = true
          break
        case 'RMHD下载':
        case '/rmhd':
          if (getUser()) {
            window.location.href = '/special-page?pageTitle=RMHD下载&detailPage=DownloadDetailPage'
          } else {
            this.loginStatus = true
          }
          break
        case '/about':
          this.$router.push('/about')
          this.tabsName = '关于我们'
          break
        default:
          if (this.navList.length > 0) {
            window.location.href = this.navPath[key]
          }
      }
    },
    resignFn(data) {
      this.loginData = data
    },
    loginBtnFn() {
      this.loginStatus = true
    },
    changeStatus(type) {
      this.loginStatus = false
      if (type == 1) {
        this.registeredState = true
      } else if (type == 2) {
        this.fargetState = true
      }
    },
    closeRegisterFn(val) {
      this.registeredState = false
      if (val) this.loginStatus = true
    },
    forgetFn() {
      this.fargetState = false
    }
  },
  mounted() {
    const userData = getUser()
    if (userData) {
      const user = JSON.parse(userData)
      this.$store.state.name = user ? user.name : ''
    }
    EventBus.$on('getUser', (user) => {
      this.$store.state.name = user.name
    })
    EventBus.$on('clearSearchText', () => {
      this.searchText = ''
    })
  }
}
</script>

<style lang="scss" scoped>

.header {
  width: 100%;
  height: $header-height;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.83), rgba(0, 0, 0, 0.01));
  z-index: 9;
  position: relative;
}

.headerbox {
  height: $header-height;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
}

.logo {
  width: 135px;
  height: 37px;
  flex-shrink: 0;

  img {
    width: 135px;
    height: 37px;
  }
}

.list {
  display: flex;
  align-items: flex-end;
  width: 670px;
  justify-content: space-between;
  margin-left: 54px;
  margin-right: 66px;
  box-sizing: border-box;
  cursor: pointer;
  border-right: 0;
  flex-shrink: 0;
  border: none !important;

  .el-menu-item {
    height: auto !important;
    line-height: inherit !important;
    border: none !important;
    padding: 0 !important;
    font-family: PingFang;
    font-weight: 400;
    font-size: 18px !important;
    color: #fff;

    &.is-active {
      font-size: 18px;
    }

    span.select {
      font-size: 24px !important;
    }
  }

  .el-menu-item:focus, .el-menu-item:hover {
    background-color: transparent !important;
  }
}

.search {
  position: relative;

  input {
    width: 190px;
    height: 36px;
    background: hsla(0, 0%, 100%, 0.4);
    border-radius: 4px;
    color: #fff;
    outline: none;
    border: none;
    padding-left: 15px;
    padding-right: 42px;
    font-family: PingFang;
    font-weight: 400;
    font-size: 18px;
    box-sizing: border-box;

    &::placeholder {
      color: hsla(0, 0%, 100%, 0.6);
    }
  }

  img {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 9px;
    cursor: pointer;
  }

  .line {
    height: 18px;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 36px;
    width: 1px;
    background-color: #fff3ff;
    opacity: 0.23;
  }
}

.xiazai {
  margin: 0 49px 0 44px;
  cursor: pointer;

  &, img {
    width: 100px;
    height: 32px;
  }
}

.touxiang {
  cursor: pointer;
  border-radius: 50%;
  background-color: #d2e0e2;

  &, img {
    width: 40px;
    height: 40px;
  }
}
</style>
